"use strict";

var _regeneratorRuntime = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var web3_provider_engine_1 = __importDefault(require("web3-provider-engine"));

var hooked_wallet_1 = __importDefault(require("web3-provider-engine/subproviders/hooked-wallet"));

var rpc_1 = __importDefault(require("web3-provider-engine/subproviders/rpc"));

var web3Utils = __importStar(require("web3-utils"));

var utils = __importStar(require("./utils"));

var AuthereumAdminKeyProvider =
/*#__PURE__*/
function (_web3_provider_engine) {
  _inherits(AuthereumAdminKeyProvider, _web3_provider_engine);

  function AuthereumAdminKeyProvider(adminPrivateKey, networkUrl) {
    var _this;

    _classCallCheck(this, AuthereumAdminKeyProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AuthereumAdminKeyProvider).call(this));
    _this.adminPrivateKey = adminPrivateKey;
    _this.rpcUri = networkUrl;
    _this.isAuthereum = true;

    _this.initSubprovider();

    return _this;
  }

  _createClass(AuthereumAdminKeyProvider, [{
    key: "initSubprovider",
    value: function initSubprovider() {
      var _this2 = this;

      var _super = Object.create(null, {
        addProvider: {
          get: function get() {
            return _get(_getPrototypeOf(AuthereumAdminKeyProvider.prototype), "addProvider", _this2);
          }
        },
        on: {
          get: function get() {
            return _get(_getPrototypeOf(AuthereumAdminKeyProvider.prototype), "on", _this2);
          }
        },
        start: {
          get: function get() {
            return _get(_getPrototypeOf(AuthereumAdminKeyProvider.prototype), "start", _this2);
          }
        }
      });

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var _this3 = this;

        var walletSubprovider;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                walletSubprovider = new hooked_wallet_1.default({
                  getAccounts: function getAccounts(cb) {
                    return __awaiter(_this3, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      var accountAddress;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              // const accountAddress = utils.privateKeyToAddress(this.adminPrivateKey)
                              accountAddress = '0x925BFe6ebDC9171d4dECd8dCA8CB250A276Af39c';
                              cb(null, [accountAddress]);
                              return _context.abrupt("return", [accountAddress]);

                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));
                  },
                  approveTransaction: function approveTransaction(txData, cb) {
                    return __awaiter(_this3, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee2() {
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              cb(null, true);

                            case 1:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));
                  },
                  approveMessage: function approveMessage(msgParams, cb) {
                    return __awaiter(_this3, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee3() {
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              cb(null, true);

                            case 1:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));
                  },
                  signMessage: function signMessage(msgParams, cb) {
                    return __awaiter(_this3, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee4() {
                      var sig;
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.prev = 0;
                              _context4.next = 3;
                              return utils.signWithPrivateKey(msgParams.data, this.adminPrivateKey, this.rpcUri);

                            case 3:
                              sig = _context4.sent;
                              cb(null, sig);
                              return _context4.abrupt("return", sig);

                            case 8:
                              _context4.prev = 8;
                              _context4.t0 = _context4["catch"](0);
                              cb(_context4.t0);

                            case 11:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4, this, [[0, 8]]);
                    }));
                  },
                  signTransaction: function signTransaction(txData, cb) {
                    return __awaiter(_this3, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee6() {
                      var _this4 = this;

                      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              // TODO: best practices for min gas (21000)
                              if (web3Utils.toHex(txData.gas) === '0x5208') {
                                txData.gas = web3Utils.toHex(500000);
                              }

                              walletSubprovider.fillInTxExtras(txData, function (err, txWithExtras) {
                                return __awaiter(_this4, void 0, void 0,
                                /*#__PURE__*/
                                _regeneratorRuntime.mark(function _callee5() {
                                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                                    while (1) {
                                      switch (_context5.prev = _context5.next) {
                                        case 0:
                                          if (!err) {
                                            _context5.next = 3;
                                            break;
                                          }

                                          cb(err);
                                          return _context5.abrupt("return", false);

                                        case 3:
                                          txWithExtras.gasPrice = web3Utils.toHex(txWithExtras.gasPrice);
                                          txWithExtras.gas = utils.normalizeHex(txWithExtras.gas);
                                          txWithExtras.gasPrice = utils.normalizeHex(txWithExtras.gasPrice);
                                          txWithExtras.value = utils.normalizeHex(txWithExtras.value);
                                          txWithExtras.data = utils.normalizeHex(txWithExtras.data);
                                          _context5.prev = 8;

                                          /*
                                          const res = await this.authereum.signTransactionWithLoginKey(txWithExtras)
                                                           if (!res) {
                                            cb(new Error('No transaction data returned'))
                                            return
                                          }
                                                           cb(null, res.signedTransactionData)
                                          return res.signedTransactionData
                                           */
                                          cb(null, '0x');
                                          return _context5.abrupt("return", '0x');

                                        case 13:
                                          _context5.prev = 13;
                                          _context5.t0 = _context5["catch"](8);
                                          cb(_context5.t0);
                                          this.notifier.notify('error', _context5.t0.message, {
                                            timeout: 5000
                                          });

                                        case 17:
                                        case "end":
                                          return _context5.stop();
                                      }
                                    }
                                  }, _callee5, this, [[8, 13]]);
                                }));
                              });

                            case 2:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));
                  },
                  validateSender: function validateSender(from, cb) {
                    cb(null);
                  },
                  validateTransaction: function validateTransaction(txParams, cb) {
                    cb(null);
                  },
                  validateMessage: function validateMessage(msgParams, cb) {
                    cb(null);
                  },
                  validatePersonalMessage: function validatePersonalMessage(msgParams, cb) {
                    cb(null);
                  },
                  approvePersonalMessage: function approvePersonalMessage(msgParams, cb) {
                    return __awaiter(_this3, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee7() {
                      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              cb(null, true);

                            case 1:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee7);
                    }));
                  },
                  signPersonalMessage: function signPersonalMessage(msgParams, cb) {
                    return __awaiter(_this3, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee8() {
                      var sig;
                      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              _context8.prev = 0;
                              _context8.next = 3;
                              return utils.signWithPrivateKey(msgParams.data, this.adminPrivateKey, this.rpcUri);

                            case 3:
                              sig = _context8.sent;
                              cb(null, sig);
                              return _context8.abrupt("return", sig);

                            case 8:
                              _context8.prev = 8;
                              _context8.t0 = _context8["catch"](0);
                              cb(_context8.t0);

                            case 11:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8, this, [[0, 8]]);
                    }));
                  }
                });

                _super.addProvider.call(this, walletSubprovider);

                this.rpcSubProvider = new rpc_1.default({
                  rpcUrl: this.rpcUri
                });

                _super.addProvider.call(this, this.rpcSubProvider); // network connectivity error


                _super.on.call(this, 'error', function (err) {
                  console.error(err.stack);
                }); // start polling


                _super.start.call(this);

                this._blockTracker.removeAllListeners();

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "enable",
    value: function enable() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
    }
  }, {
    key: "disable",
    value: function disable() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
    }
  }]);

  return AuthereumAdminKeyProvider;
}(web3_provider_engine_1.default);

exports.default = AuthereumAdminKeyProvider;